import type { IShopSelectFilter } from "../types";
import { ShopSelectShopType } from "../enums";
import { LABEL_SHOP_ALL } from "../constants";
import { SHOPS_NAMES_MAP } from "./shops";

export const FILTERS_SHOPS_ARRAY: IShopSelectFilter[] = [
  {
    type: null,
    label: LABEL_SHOP_ALL,
  },
  {
    type: ShopSelectShopType.AtHouse,
    label: SHOPS_NAMES_MAP[ShopSelectShopType.AtHouse],
  },
  {
    type: ShopSelectShopType.Cosmetic,
    label: SHOPS_NAMES_MAP[ShopSelectShopType.Cosmetic],
  },
  {
    type: ShopSelectShopType.Pharmacy,
    label: SHOPS_NAMES_MAP[ShopSelectShopType.Pharmacy],
  },
  {
    type: ShopSelectShopType.Family,
    label: SHOPS_NAMES_MAP[ShopSelectShopType.Family],
  },
  {
    type: ShopSelectShopType.Extra,
    label: SHOPS_NAMES_MAP[ShopSelectShopType.Extra],
  },
];
